import { HttpParams } from "@angular/common/http"
import { ServerDataSource } from "angular2-smart-table"
import { Observable } from "rxjs"
import { DatePipe } from '@angular/common';
import { options } from "@fullcalendar/core/preact";
import { EntityConfigTemplate } from "./common/entity-config.interface";
import { ROLES } from "../../@auth/roles";

const dPipe: DatePipe = new DatePipe('en');
export interface LeaveRequest {
  documentId: string
  person: any
  type: string
  startDate: Date
  endDate: Date
  reason: Text
  leaveStatus: string
  requestedAt: Date
  reviewedBy: any
  reviewedAt?: Date
}

const LeaveRequestStatuses = [
  { value: 'pending', title: 'Pending' },
  { value: 'approved', title: 'Approved' },
  { value: 'rejected', title: 'Rejected' },
  { value: 'cancelled', title: 'Cancelled' },

];

const LeaveRequestTypes = [
  { value: 'sick', title: 'Sick (uncertified)' },
  // certified sick: always paid in full and not counted against the 12-day sick entitlement
  { value: 'medical', title: 'Medical (certified sick)' },
  { value: 'vacation', title: 'Vacation' },
  { value: 'maternity', title: 'Maternity' },
  { value: 'paternity', title: 'Paternity' },
  { value: 'bereavement', title: 'Bereavement' },
  { value: 'unpaid', title: 'Unpaid' },
];

export const LeaveRequestConfig: EntityConfigTemplate = {
  meta: { entityName: "leave-request", entityPluralName: "leave-requests", titleField: 'type', attachedToField: 'person', view: false}, //view:false is used to hide this attr from views
  type: { title: "Type", type: "select", options: LeaveRequestTypes},
  startDate: { title: 'Start Date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), type: 'date' },
  endDate: { title: 'End Date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), type: 'date' },
  daysConsumed: { title: "Days Consumed", type: "number", },
  leaveStatus: {
    title: "Status", type: "select", options: LeaveRequestStatuses, default: "pending",
    optionsByAccess: [
      {
        access: { requiredRoles: { roles: [ROLES.ADMIN], combineMode: 'any' } },
        options: LeaveRequestStatuses,
      },
      {
        access: { requiredRoles: { roles: [ROLES.STAFF], combineMode: 'any' } },
        options: [{ value: 'pending', title: 'Pending' }],
      },
      {
        access: true,
        options: [],
      },
    ]
  },
  person: { view: false, isPrefilled: true, isForeignKey: true, title: 'Person', valuePrep: (_:any, row) => `${row?.person?.firstName} ${row?.person?.lastName}`  },
  requestedAt: { 
    title: "Requested At", 
    type: "date", valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy  HH:mm'),
    editable: { requiredRoles: { roles: [ROLES.ADMIN], combineMode: 'any' } },
    placeholder: '-',
  },
  reviewedBy: {
    title: "Reviewed By",
    valuePrep: (_cell_, row) => row?.reviewedBy ? `${row?.reviewedBy?.firstName} ${row?.reviewedBy?.lastName}` : '',
    editable: { requiredRoles: { roles: [ROLES.ADMIN], combineMode: 'any' } },
    placeholder: '-',

  },
  reviewedAt: { 
    title: "Reviewed At", 
    type: "date", valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy  HH:mm'), 
    editable: { requiredRoles: { roles: [ROLES.ADMIN], combineMode: 'any' } },
    placeholder: '-'
  },
}

export abstract class LeaveRequestsData {
  abstract get gridDataSource(): ServerDataSource;
  abstract listAll(): Observable<LeaveRequest[]>;
  abstract list(pageNumber: number, pageSize: number): Observable<LeaveRequest[]>;
  abstract rawQry(pageNumber: number, pageSize: number, params: HttpParams): Observable<LeaveRequest[]>;
  abstract get(id: string): Observable<LeaveRequest>;
  abstract update(LeaveRequest: LeaveRequest): Observable<LeaveRequest>;
  abstract create(LeaveRequest: LeaveRequest): Observable<LeaveRequest>;
  abstract delete(id: string): Observable<boolean>;
}
